


























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Account } from '@/api/generated'
import UnauthenticatedUserBar from '@/main/header/unauthenticated-user-bar.vue'
import AuthenticatedUserBar from '@/main/header/authenticated-user-bar.vue'

@Component({
  components: { AuthenticatedUserBar, UnauthenticatedUserBar },
})
export default class HeaderUserBar extends Vue {
  @Prop({
    type: Object,
  })
  public readonly activeUser!: Account

  @Prop({
    type: Boolean,
  })
  public readonly isAdmin!: boolean
}
